<template>
  <div id="content">
    <Navbar />
    <v-container class="py-8" fluid max-width="1200">
      <v-row justify="center" align="start" class="mb-8 mt-5">
        <v-col cols="12" md="8">
          <v-card class="pa-4 rounded-lg" elevation="2">
            <h2 class="text-h5 mb-4">Payment Method</h2>

            <!-- eSewa Payment Option -->
            <!-- <v-card class="mb-4 pa-4" :class="{ 'border-primary': paymentMethod === 'esewa' }"
              @click="paymentMethod = 'esewa'" variant="outlined">
              <div class="d-flex align-center">
                <img src="https://cdn.esewa.com.np/ui/images/logos/esewa-icon-large.png" alt="eSewa"
                  style="height: 30px; margin-right: 16px" />
                <span class="text-body-1">Pay with eSewa</span>
                <v-spacer></v-spacer>
                <v-icon v-if="paymentMethod === 'esewa'">mdi-check-circle</v-icon>
              </div>
            </v-card> -->

            <!-- Khalti Payment Option -->
            <!-- <v-card class="mb-4 pa-4" :class="{ 'border-primary': paymentMethod === 'khalti' }"
              @click="paymentMethod = 'khalti'" variant="outlined">
              <div class="d-flex align-center">
                <img :src="khalti" alt="khalti" style="height: 30px; margin-right: 16px" />
                <span class="text-body-1">Pay with Khalti</span>
                <v-spacer></v-spacer>
                <v-icon v-if="paymentMethod === 'khalti'">mdi-check-circle</v-icon>
              </div>
            </v-card> -->

            <!-- Cash on Delivery -->
            <v-card class="pa-4" :class="{ 'border-primary': paymentMethod === 'cod' }" @click="paymentMethod = 'cod'"
              variant="outlined">
              <div class="d-flex align-center">
                <v-icon size="30" class="mr-4">mdi-cash</v-icon>
                <span class="text-body-1">Cash on Delivery</span>
                <v-spacer></v-spacer>
                <v-icon v-if="paymentMethod === 'cod'">mdi-check-circle</v-icon>
              </div>
            </v-card>

            <!-- Place Order Button -->
            <!-- <v-btn block color="primary" size="large" class="mt-6" @click="placeOrder" :loading="processing">
              Place Order
            </v-btn> -->
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="mb-8">
          <OrderSummary :cart-items="cartStore.cart" :grand-total="grandTotal" :tax-amount="taxAmount"
            :total-with-tax="totalWithTax" :disabled="!paymentMethod" btn-text="Place Order" @click="placeOrder"
            :loading="processing" />
          <v-alert type="info" v-if="!paymentMethod" class="mb-4 mt-2" dense>
            Please select a payment method to proceed.
          </v-alert>

        </v-col>
      </v-row>

      <form v-if="paymentMethod === 'esewa'" ref="esewaForm" method="POST"
        action="https://rc-epay.esewa.com.np/api/epay/main/v2/form" style="display: none">
        <input type="hidden" id="amount" name="amount" :value="totalWithTax" />
        <input type="hidden" id="tax_amount" name="tax_amount" :value="taxAmount" />
        <input type="hidden" id="total_amount" name="total_amount" :value="totalWithTax" />
        <input type="hidden" id="transaction_uuid" name="transaction_uuid" :value="transactionId" />
        <input type="hidden" id="product_code" name="product_code" value="EPAYTEST" />
        <input type="hidden" id="product_service_charge" name="product_service_charge" value="0" />
        <input type="hidden" id="product_delivery_charge" name="product_delivery_charge" :value="shippingFee" />
        <input type="hidden" id="success_url" name="success_url" :value="successUrl" />
        <input type="hidden" id="failure_url" name="failure_url" :value="failureUrl" />
        <input type="hidden" id="signed_field_names" name="signed_field_names"
          value="total_amount,transaction_uuid,product_code" />
        <input type="hidden" id="signature" name="signature" :value="signature" />
      </form>
    </v-container>

    <v-dialog v-model="showCodDialog" persistent max-width="500">
      <v-card elevation="4" class="rounded-lg pa-4">
        <!-- Title -->
        <v-card-title class="text-h6 font-weight-bold d-flex align-center">
          <v-icon left class="mr-2" color="primary">mdi-truck-check</v-icon>
          Confirm Your Order
        </v-card-title>

        <v-divider class="my-2"></v-divider>

        <!-- Dialog Body -->
        <v-card-text class="pt-2">
          <p class="mb-4">
            Are you sure you want to place a <strong>Cash on Delivery</strong> order?
          </p>

          <!-- Shipping Address Section -->
          <v-sheet elevation="0" class="mb-4 pa-4" color="#f5f5f5" rounded>
            <h6 class="text-subtitle-1 font-weight-bold mb-2">Shipping Address</h6>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><strong>Name:</strong> {{ shippingAddress.fullName }}</v-list-item-title>
                  <v-list-item-title><strong>Phone:</strong> {{ shippingAddress.phone }}</v-list-item-title>
                  <v-list-item-title><strong>Email:</strong> {{ shippingAddress.email }}</v-list-item-title>
                  <v-list-item-title>
                    <strong>Address:</strong>
                    <div style="word-wrap: break-word;">
                      {{ shippingAddress.street }}, {{ shippingAddress.ward }},
                      {{ shippingAddress.municipality }}, {{ shippingAddress.district }},
                      {{ shippingAddress.province }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-title><strong>Note:</strong>{{ shippingAddress.note }} </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>

          <!-- Totals -->
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Shipping Fee</td>
                  <td class="text-right">Rs. {{ shippingFee }}</td>
                </tr>
                <tr class="font-weight-bold">
                  <td>Grand Total</td>
                  <td class="text-right">Rs. {{ grandTotal }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <!-- Actions -->
        <v-card-actions class="justify-end">
          <v-btn color="grey lighten-1" text @click="showCodDialog = false">Cancel</v-btn>
          <v-btn color="primary" dark @click="confirmCodOrder">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import khalti from "@/assets/images/khalti.png";
import { useCartStore } from "@/Store/cartStore";
import OrderSummary from "../components/SharedUI/OrderSummary.vue";
import Navbar from "../components/Navbar.vue";
import CryptoJS from "crypto-js";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";

const router = useRouter();
const cartStore = useCartStore();
const loading = ref(false);
const esewaForm = ref(null);

// Payment state
const paymentMethod = ref("");
const processing = ref(false);

// Order calculations
const subtotal = computed(() => cartStore.subtotal || 0);
const shippingFee = computed(() => cartStore.shippingFee || 0);
const taxAmount = computed(() => cartStore.taxAmount || 0);
const totalWithTax = computed(() => cartStore.totalWithTax || 0);
const grandTotal = computed(() => cartStore.grandTotal || 0);

// const shippingAddress = localStorage.getItem('shippingAddress');
const shippingAddress = computed(() => {
  const address = localStorage.getItem("shippingAddress");
  return address ? JSON.parse(address) : null;
});

const showCodDialog = ref(false);

const confirmCodOrder = async () => {
  showCodDialog.value = false;
  processing.value = true;

  try {
    // Retrieve and parse the shipping address from localStorage
    const shippingAddress = JSON.parse(localStorage.getItem("shippingAddress"));

    // Extract the necessary fields from the shipping address
    const {
      fullName,
      phone,
      email,
      province,
      district,
      municipality,
      ward,
      street,
      note,
    } = shippingAddress;

    // Prepare the order data
    const orderData = {
      payment_method: paymentMethod.value,
      order_items: cartStore.cart.map((item) => ({
        service_detail_id: item.id,
        quantity: item.quantity,
        price: item.current_price,
      })),
      name: fullName,
      contact: phone,
      email: email,
      province: province,
      district: district,
      municipality: municipality,
      ward: ward,
      street: street,
      notes: note,
    };

    // Send the order data to your API endpoint
    const response = await fetch(
      `${apiConfig.baseUrl}${apiConfig.verifyOrder}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
      }
    );

    const data = await response.json();
    // console.log("Order submitted successfully:", data);

    cartStore.cart = [];
    localStorage.removeItem("cart");
    localStorage.removeItem("shippingAddress");

    Swal.fire({
      icon: "success",
      position: "top-end",
      toast: true,
      showCloseButton: true,
      showCancelButton: false,
      showDenyButton: false,
      title: "Order placed successfully",
      text: "Your order has been placed successfully.",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    setTimeout(() => {

      router.push("/");
    }, 3000);


  } catch (error) {
    console.error("Error submitting order:", error);
  } finally {
    processing.value = false; // Reset processing state
  }
};

// eSewa integration
const transactionId = computed(
  () => `TXN-${Date.now()}-${Math.floor(Math.random() * 1000)}`
);
const successUrl = computed(() => `${window.location.origin}/order-success`);
const failureUrl = computed(() => `${window.location.origin}/order-failed`);

// Note: Replace with your actual eSewa merchant secret
const signature = computed(() => {
  const secret = "8gBm/:&EnhH.1/q"; // Test secret key
  const data = `total_amount=${totalWithTax.value},transaction_uuid=${transactionId.value},product_code=EPAYTEST`;
  return CryptoJS.HmacSHA256(data, secret).toString(CryptoJS.enc.Base64);
});



// In your script setup
const khaltiCheckout = ref(null);

const loadKhaltiCheckout = () => {
  return new Promise((resolve, reject) => {
    if (window.KhaltiCheckout) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://khalti.s3.ap-south-1.amazonaws.com/KPG/dist/2020.12.17.0.0.0/khalti-checkout.iffe.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Khalti script"));
    document.body.appendChild(script);
  });
};

const initiateKhaltiPayment = async () => {
  processing.value = true;

  try {
    // Ensure Khalti is loaded
    if (!window.KhaltiCheckout) {
      await loadKhaltiCheckout();
    }

    // Convert amount to paisa (Khalti's requirement)
    const amountInPaisa = Math.round(totalWithTax.value * 100);

    // Validate minimum amount (10 NPR)
    if (amountInPaisa < 1000) {
      throw new Error("Minimum payment amount is ₹10 (10 NPR)");
    }

    // Initialize Khalti Checkout with eventHandler
    khaltiCheckout.value = new window.KhaltiCheckout({
      publicKey: "test_public_key_dc74e2053f4b48e1bfa8b5da772e661a",
      productIdentity: transactionId.value,
      productName: "Order Payment",
      productUrl: window.location.href,
      paymentPreference: ["KHALTI", "EBANKING", "MOBILE_BANKING", "CONNECT_IPS", "SCT"],
      eventHandler: {
        onSuccess(payload) {
          // console.log("Payment successful", payload);
          // Store payment details
          localStorage.setItem('khaltiPayment', JSON.stringify({
            ...payload,
            orderId: transactionId.value,
            items: cartStore.cart,
            amount: totalWithTax.value,
            timestamp: new Date().toISOString()
          }));
          router.push("/order-success");
        },
        onError(error) {
          console.error("Payment failed", error);
          alert("Payment failed. Please try again.");
          processing.value = false;
        },
        onClose() {
          // console.log("Widget closed");
          processing.value = false;
        }
      }
    });

    // Show the payment dialog
    khaltiCheckout.value.show({ amount: amountInPaisa });

  } catch (error) {
    console.error("Payment error:", error);
    alert(`Payment error: ${error.message}`);
    processing.value = false;
  }
};

const placeOrder = () => {
   if (!paymentMethod.value) {
    Swal.fire('Please select a payment method to continue.');
    return;
  }
  if (paymentMethod.value === "esewa") {
    if (esewaForm.value) esewaForm.value.submit();
  } else if (paymentMethod.value === "khalti") {
    initiateKhaltiPayment();
  } else if (paymentMethod.value === "cod") {
    showCodDialog.value = true;
  }
};

onMounted(() => {
  if (paymentMethod.value === "khalti") {
    loadKhaltiCheckout().catch((error) => {
      console.error("Failed to pre-load Khalti:", error);
    });
  }
});
</script>

<style scoped>
.border-primary {
  border: 2px solid rgb(var(--v-theme-primary));
}
</style>
